import React from "react";

type FilePreviewerProps = {
  url: string;
};

const getFileExtension = (url: string): string | null => {
  try {
    const pathname = new URL(url).pathname;
    const filename = pathname.split('/').pop() || '';
    const match = filename.match(/\.(\w+)$/);
    return match ? match[1].toLowerCase() : null;
  } catch (error) {
    console.error("Invalid URL", error);
    return null;
  }
};

const FilePreviewer: React.FC<FilePreviewerProps> = ({ url }) => {
  const extension = getFileExtension(url);
 
  if (!extension) return <div>Unable to detect file type.</div>;

  if (["jpg", "jpeg", "png", "gif", "webp"].includes(extension)) {
    return (
      <div>
        <img src={url} alt="Preview" style={{ maxWidth: "100%", maxHeight: "500px" }} />
      </div>
    );
  }

  if (extension === "pdf") {
    return (
      <div>
        <iframe
          src={url}
          title="PDF Preview"
          width="100%"
          height="500px"
          style={{ border: "none" }}
        />
      </div>
    );
  }

  return <div>Preview not available for .{extension} files.</div>;
};

export default FilePreviewer;
